module.exports = __webpack_public_path__ + "53e98e67c99159f00c6560c0d6e8e65b.glb";